import React from 'react';
import { Button } from './ui/button';
import { Github, BookOpen, ArrowRight } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="pt-32 pb-20 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center space-y-8">
          <div className="inline-block">
            <span className="inline-flex items-center px-4 py-2 rounded-full bg-blue-500/10 text-blue-600 dark:text-blue-400 text-sm font-medium border border-blue-500/20">
              Open Source • Self-Host or Use Our Platform
            </span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
            See what your AI agents
            <br />
            <span className="text-blue-600 dark:text-blue-400">actually do</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Drop-in observability for Claude Agent SDK. One line change. Full traces, tool calls, and costs.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button
              size="lg"
              asChild
              className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-6 rounded-lg transition-all hover:scale-105"
            >
              <a href="https://github.com/getagentd/agentd-py" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2">
                <Github className="h-5 w-5" />
                <span>Get Started</span>
                <ArrowRight className="h-5 w-5" />
              </a>
            </Button>
            <Button
              size="lg"
              variant="outline"
              asChild
              className="text-lg px-8 py-6 rounded-lg border-2 transition-all hover:scale-105"
            >
              <a href="https://github.com/getagentd/agentd-py" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2">
                <BookOpen className="h-5 w-5" />
                <span>View Docs</span>
              </a>
            </Button>
          </div>

          <div className="pt-12 max-w-2xl mx-auto">
            <div className="bg-card border border-border rounded-xl p-8 shadow-2xl backdrop-blur-sm">
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm font-medium text-muted-foreground">One line change</span>
                <div className="flex space-x-2">
                  <div className="w-3 h-3 rounded-full bg-red-500"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                  <div className="w-3 h-3 rounded-full bg-green-500"></div>
                </div>
              </div>
              <pre className="text-left text-sm md:text-base">
                <code className="font-mono">
                  <span className="text-gray-500"># Before</span>
                  {"\n"}
                  <span className="text-red-400">from</span> <span className="text-blue-400">claude_agent_sdk</span> <span className="text-red-400">import</span> query
                  {"\n\n"}
                  <span className="text-gray-500"># After (that's it)</span>
                  {"\n"}
                  <span className="text-red-400">from</span> <span className="text-blue-400">agentd</span> <span className="text-red-400">import</span> query
                </code>
              </pre>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;